import { ExternalLink, Star } from "lucide-react";
import { useLang } from "../LanguageContext";
import { Chapter, Reveal } from "./Chapter";

const REVIEWS_URL = "https://www.google.com/search?sca_esv=b1c981e37f55a22b&sxsrf=APpeQnuXGrDWadd3v5cagrnTvPju_bsQyA:1788460419827&q=Eros+Zannoni+Naturopata+-+Metodo+SynergyA&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_294BL7usU99ghnBDR3rO-Kz2hfgSEHiFePzS7wcbz6D_xYNuXFGibNN8oQvjEkUhOEj-_8%3D&uds=AJ5uw1-tbjUcePkIaC2yI56QR5nXdQJU6QS7gH09FDFx2F9wEY6RYKGOD62CUtQPWeUHFLUUIYW5CaIHjmlpYLnS8hD4M7oTP4lQsio05xENRePDG9jTHl7L0l35FAhvEH-g0clSLJe8N6820j92kVwkZl6bEsOBMw&sa=X&sqi=2&ved=2ahUKEwjs2ZKghtOWAxUrR_4FHen2ArgQ3PALegQIHBAE&biw=1342&bih=808&dpr=2.2";

const Testimonials = () => {
  const { t } = useLang();
  const ts = t.testimonials;

  return (
    <Chapter id="testimonianze" num={ts.num} kicker={ts.kicker} title={ts.title}>
      <Reveal>
        <div className="mb-12 flex flex-wrap items-center gap-5">
          <div data-testid="google-rating-badge" className="flex items-center gap-4 border border-ink/10 bg-linen px-6 py-4">
            <span className="font-serif text-4xl font-light text-forest">5,0</span>
            <span className="flex flex-col gap-1.5">
              <span className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-3.5 w-3.5 fill-gold text-gold" strokeWidth={1} />
                ))}
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-moss">{ts.googleBadge}</span>
            </span>
          </div>
          <a
            data-testid="google-reviews-link"
            href={REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 rounded-full border border-ink/15 px-7 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-forest transition-colors duration-300 hover:bg-forest hover:text-linen"
          >
            {ts.reviewsCta}
            <ExternalLink className="h-3.5 w-3.5 opacity-50 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.5} />
          </a>
        </div>
      </Reveal>
      <div
        data-testid="reviews-marquee"
        className="relative overflow-hidden"
        style={{
          maskImage: "linear-gradient(90deg, transparent, black 6%, black 94%, transparent)",
          WebkitMaskImage: "linear-gradient(90deg, transparent, black 6%, black 94%, transparent)",
        }}
      >
        <div className="marquee-reviews flex w-max gap-5 py-2">
          {[...ts.items, ...ts.items, ...ts.items].map((item, i) => {
            const dark = i % 3 === 1;
            return (
              <figure
                key={i}
                data-testid={i < ts.items.length ? `testimonial-${i + 1}` : undefined}
                className={`flex w-[300px] shrink-0 flex-col p-7 sm:w-[400px] sm:p-9 ${dark ? "bg-forest text-linen" : "border border-ink/10 bg-linen"}`}
              >
                <span className={`font-serif text-5xl font-light leading-none ${dark ? "text-gold" : "text-terra"}`}>“</span>
                <blockquote className={`mt-2 flex-1 text-sm font-light leading-relaxed sm:text-base ${dark ? "text-linen/85" : "text-ink/85"}`}>
                  {item.quote}
                </blockquote>
                <figcaption className="mt-6 flex items-center justify-between">
                  <span className={`font-mono text-[11px] uppercase tracking-[0.25em] ${dark ? "text-gold" : "text-terra"}`}>
                    {item.name}
                  </span>
                  <span className="flex gap-1">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className={`h-3 w-3 ${dark ? "fill-gold text-gold" : "fill-terra text-terra"}`} strokeWidth={1} />
                    ))}
                  </span>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </Chapter>
  );
};

export default Testimonials;
